import type {
  BaseExecutionLiveDetails,
  BaseExecutionOrderBookResponse,
  BaseExecutionTaskRow,
} from "src/Requests/baseMarketMaking";

const validRange = (min?: number | null, max?: number | null) =>
  min != null && max != null && Number.isFinite(min) && Number.isFinite(max) &&
    min > 0 && max >= min ? { min, max } : null;

export const getBasePriceRange = (
  live: BaseExecutionLiveDetails | null,
  statistic: BaseExecutionOrderBookResponse["instrumentStatistic"],
  task: BaseExecutionTaskRow | null,
) => {
  // An explicit live result (including missing/bypassed limits) is authoritative.
  // Fallbacks only cover loading and API versions without these fields.
  if (live && (live.priceLimitsBypassed !== undefined ||
    live.minPricePermit !== undefined || live.maxPricePermit !== undefined)) {
    return live.priceLimitsBypassed ? null : validRange(live.minPricePermit, live.maxPricePermit);
  }
  return validRange(statistic?.minPricePermit, statistic?.maxPricePermit) ??
    validRange(task?.minPricePermit, task?.maxPricePermit);
};
